import React from 'react';

export default function FromTo(props) {
  const { fromTo, distance } = props;

  return (
    <React.Fragment>
      <div>
        {fromTo} {distance && `(${distance.trim()})`}
      </div>
      {/* {departFrom && <div>{departFrom}</div>} */}
      {/* <div>
        {departureTime && arrivalTime && `(${departureTime} - ${arrivalTime})`} {duration && <span>({duration})</span>}
      </div> */}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationList/FromTo.js